export const heroSlides = [
  {
    id: 1,
    title: '凪光 第一季',
    subtitle: '人气动漫大作，凪与光的奇幻冒险之旅正式开启',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20cinematic%20hero%20art%20featuring%20a%20young%20warrior%20with%20flowing%20hair%20standing%20on%20a%20cliff%20overlooking%20a%20magical%20ocean%20at%20sunset%2C%20dramatic%20warm%20golden%20lighting%2C%20sparkling%20particles%20in%20the%20air%2C%20epic%20fantasy%20atmosphere%2C%20Japanese%20animation%20style%20with%20detailed%20backgrounds&width=1600&height=900&seq=nagi-hero-01&orientation=landscape',
    link: '/article/nagihikari-s1',
  },
  {
    id: 2,
    title: '凪光 第二季：深海之章',
    subtitle: '全新篇章启程，探索深海的秘密与未知的力量',
    image: 'https://readdy.ai/api/search-image?query=Anime%20cinematic%20scene%20of%20a%20mysterious%20girl%20with%20silver%20hair%20in%20an%20underwater%20temple%2C%20glowing%20coral%20reefs%2C%20bioluminescent%20creatures%2C%20deep%20ocean%20ambient%20light%2C%20ethereal%20warm%20teal%20and%20gold%20color%20palette%2C%20fantasy%20animation%20art%20style%2C%20epic%20scale&width=1600&height=900&seq=nagi-hero-02&orientation=landscape',
    link: '/article/nagihikari-s2',
  },
  {
    id: 3,
    title: '凪光 剧场版：永恒之约',
    subtitle: '震撼大银幕巨作，凪与光的最终命运将何去何从',
    image: 'https://readdy.ai/api/search-image?query=Epic%20anime%20movie%20poster%20style%20art%20showing%20two%20characters%20facing%20each%20other%20under%20a%20starlit%20sky%2C%20one%20with%20flame%20aura%20one%20with%20water%20aura%2C%20cherry%20blossoms%20floating%2C%20ancient%20temple%20ruins%20in%20background%2C%20dramatic%20warm%20lighting%2C%20Japanese%20animation%20cinematic%20style&width=1600&height=900&seq=nagi-hero-03&orientation=landscape',
    link: '/article/nagihikari-movie',
  },
];

export const categories = [
  { id: 'all', name: '全部', slug: 'all' },
  { id: 'anime', name: '动画番剧', slug: 'anime' },
  { id: 'movie', name: '剧场版', slug: 'movie' },
  { id: 'ova', name: 'OVA特典', slug: 'ova' },
  { id: 'music', name: '原声音乐', slug: 'music' },
  { id: 'news', name: '最新资讯', slug: 'news' },
  { id: 'character', name: '角色介绍', slug: 'character' },
];

export const hotArticles = [
  {
    id: 'nagihikari-s1',
    title: '凪光 第一季',
    category: '动画番剧',
    categorySlug: 'anime',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20young%20male%20protagonist%20with%20wind%20powers%20surrounded%20by%20swirling%20leaves%2C%20warm%20autumn%20color%20palette%2C%20Japanese%20high%20school%20rooftop%20setting%2C%20clean%20anime%20art%20style%2C%20soft%20lighting%2C%20beautiful%20background%20details&width=800&height=450&seq=nagi-hot-01&orientation=landscape',
    rating: 9.6,
    episodes: 24,
    status: '已完结',
    updateDate: '2025-03-15',
    views: 1580000,
    description: '平凡高中生凪在17岁生日那天发现自己拥有操控风的能力，命运的齿轮开始转动……',
  },
  {
    id: 'nagihikari-s2',
    title: '凪光 第二季：深海之章',
    category: '动画番剧',
    categorySlug: 'anime',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20visual%20of%20a%20female%20character%20with%20water%20powers%20in%20an%20underwater%20palace%2C%20flowing%20blue%20hair%2C%20surrounded%20by%20bubbles%20and%20sea%20life%2C%20crystal%20clear%20water%20lighting%2C%20fantasy%20anime%20art%20style%2C%20ethereal%20atmosphere&width=800&height=450&seq=nagi-hot-02&orientation=landscape',
    rating: 9.8,
    episodes: 24,
    status: '更新至第22话',
    updateDate: '2026-08-10',
    views: 2320000,
    description: '光的身世之谜终于揭开，深海王国的命运与凪息息相关，第二季冒险再升级！',
  },
  {
    id: 'nagihikari-movie',
    title: '凪光 剧场版：永恒之约',
    category: '剧场版',
    categorySlug: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20anime%20movie%20visual%20showing%20two%20characters%20holding%20hands%20against%20a%20burning%20sky%2C%20silhouettes%2C%20dramatic%20orange%20and%20crimson%20clouds%2C%20floating%20light%20particles%2C%20emotional%20atmosphere%2C%20cinematic%20Japanese%20animation%20style&width=800&height=450&seq=nagi-hot-03&orientation=landscape',
    rating: 9.9,
    episodes: 1,
    status: '已上映',
    updateDate: '2026-06-01',
    views: 3850000,
    description: '命运的交织迎来终章，凪与光跨越世纪的约定，将在大银幕上完美呈现。',
  },
  {
    id: 'nagihikari-ova1',
    title: '凪光 OVA：夏日的回忆',
    category: 'OVA特典',
    categorySlug: 'ova',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20slice%20of%20life%20scene%20showing%20friends%20at%20a%20summer%20festival%2C%20colorful%20fireworks%20in%20night%20sky%2C%20traditional%20yukata%20clothing%2C%20lanterns%2C%20warm%20and%20nostalgic%20atmosphere%2C%20Japanese%20anime%20visual%20style%2C%20soft%20glowing%20lights&width=800&height=450&seq=nagi-hot-04&orientation=landscape',
    rating: 9.3,
    episodes: 2,
    status: '已完结',
    updateDate: '2025-08-20',
    views: 890000,
    description: '暑假期间，凪与伙伴们一起参加夏日祭典，留下了难忘的美好回忆。',
  },
  {
    id: 'nagihikari-soundtrack',
    title: '凪光 原声音乐集「风与海之歌」',
    category: '原声音乐',
    categorySlug: 'music',
    cover: 'https://readdy.ai/api/search-image?query=Beautiful%20music%20album%20cover%20art%20featuring%20a%20grand%20piano%20on%20a%20cliff%20overlooking%20the%20ocean%20at%20sunset%2C%20musical%20notes%20floating%20in%20golden%20light%2C%20gentle%20waves%2C%20anime%20art%20style%20with%20dreamy%20aesthetic%2C%20warm%20and%20emotional%20color%20tones&width=800&height=450&seq=nagi-hot-05&orientation=landscape',
    rating: 9.7,
    episodes: 48,
    status: '已发售',
    updateDate: '2026-04-10',
    views: 670000,
    description: '收录两季动画全部原声音乐，由日本顶尖作曲家精心打造。',
  },
  {
    id: 'nagihikari-character-guide',
    title: '凪光 角色完全指南',
    category: '角色介绍',
    categorySlug: 'character',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20character%20lineup%20art%20showing%20six%20diverse%20characters%20from%20a%20fantasy%20series%2C%20each%20with%20unique%20elemental%20powers%2C%20dynamic%20poses%2C%20colorful%20outfits%2C%20clean%20anime%20illustration%20style%2C%20professional%20character%20design%20sheet%20aesthetic&width=800&height=450&seq=nagi-hot-06&orientation=landscape',
    rating: 9.2,
    episodes: 1,
    status: '已发布',
    updateDate: '2026-07-15',
    views: 450000,
    description: '从凪到光，从配角到反派，每一位角色的背景故事与能力设定全解析。',
  },
];

export const latestUpdates = [
  {
    id: 'nagihikari-s2-ep22',
    title: '凪光 第二季 第22话「深海之王的觉醒」',
    category: '动画番剧',
    updateTime: '2026-08-10',
    description: '深海之王终于现身，凪与光的联手能否抵挡这前所未有的危机？',
  },
  {
    id: 'nagihikari-s2-ep21',
    title: '凪光 第二季 第21话「失落的记忆」',
    category: '动画番剧',
    updateTime: '2026-08-03',
    description: '光在海底遗迹中发现了与自己身世密切相关的古代石板，记忆开始复苏。',
  },
  {
    id: 'nagihikari-s2-ep20',
    title: '凪光 第二季 第20话「风暴前夕」',
    category: '动画番剧',
    updateTime: '2026-07-27',
    description: '深海王国的使者突然造访陆地，带来了令人震惊的消息。',
  },
  {
    id: 'nagihikari-news-interview',
    title: '【特别企划】凪光声优专访：凪役·松本健一访谈',
    category: '最新资讯',
    updateTime: '2026-08-08',
    description: '为凪配音五年的松本健一首次深度分享角色塑造背后的故事与心路历程。',
  },
  {
    id: 'nagihikari-news-movie-bd',
    title: '凪光 剧场版BD&DVD发售决定！限定特典情报公开',
    category: '最新资讯',
    updateTime: '2026-08-05',
    description: '剧场版蓝光碟将于9月正式发售，初回限定版包含未公开影像与设定资料集。',
  },
  {
    id: 'nagihikari-s2-ep19',
    title: '凪光 第二季 第19话「潮汐的指引」',
    category: '动画番剧',
    updateTime: '2026-07-20',
    description: '凪学会了与风之精灵沟通，获得了前往深海王国的重要线索。',
  },
  {
    id: 'nagihikari-news-s3',
    title: '重磅！凪光 第三季制作决定！新视觉图解禁',
    category: '最新资讯',
    updateTime: '2026-07-10',
    description: '官方正式宣布第三季制作启动，预计2027年播出，全新冒险即将启程。',
  },
  {
    id: 'nagihikari-character-ryu',
    title: '角色深度解析：龙之继承者·炎真',
    category: '角色介绍',
    updateTime: '2026-07-18',
    description: '作为凪的宿命对手，炎真的火焰之力背后隐藏着怎样的悲剧？全方位解读。',
  },
];

export const faqs = [
  {
    question: '凪光在线观看需要下载App吗？',
    answer: '不需要！凪光在线观看支持PC端与手机端直接在线播放，无需下载任何App或插件。只需打开浏览器访问我们的网站，即可享受高清流畅的观看体验。我们采用先进的流媒体技术，确保在不同设备上都能获得最佳播放效果。',
  },
  {
    question: '凪光全集有多少部作品？播放顺序是什么？',
    answer: '凪光系列目前包括：第一季（24话）、第二季（24话，连载中）、剧场版「永恒之约」、OVA特典「夏日的回忆」等。推荐按照播出顺序观看：第一季 → OVA特典 → 第二季 → 剧场版。这个顺序能够帮助新观众更好地理解剧情发展和角色关系的变化。',
  },
  {
    question: '凪光的画质清晰吗？支持什么分辨率？',
    answer: '我们提供最高1080P全高清画质，支持720P和1080P自适应切换。根据您的网络状况自动调整最佳画质，确保播放流畅不卡顿。所有资源均经过专业的画质优化处理，即使是较旧的OVA作品也能呈现出色效果。',
  },
  {
    question: '凪光的更新频率是怎样的？',
    answer: '第二季每周五更新一话，最新资讯和角色介绍不定期更新。我们与日本播出时间保持紧密同步，通常在日本播出后24小时内即可上线中文字幕版本，让国内观众能够第一时间跟上剧情进度。',
  },
  {
    question: '网站是否完全免费？有没有隐藏收费？',
    answer: '完全免费！凪光在线观看致力于为粉丝提供优质的免费观影体验，所有内容均可免费在线观看，无任何隐藏收费或会员限制。我们通过广告收入维持网站运营，绝不会向用户收取任何费用，请放心使用。',
  },
  {
    question: '如何获取凪光的最新动态和周边信息？',
    answer: '您可以关注我们的社交媒体账号获取最新动态，也可以在网站订阅更新通知。此外，关于凪光系列的官方周边商品、声优见面会、展览活动等信息，我们都会在「最新资讯」栏目中及时发布，确保粉丝们不会错过任何精彩内容。',
  },
];